import { DeclarationDrBase } from './declaration-dr.base.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class DeclarationDr extends DeclarationDrBase {
    static jsonMap = {
        ...DeclarationDrBase.jsonMap,
        l4: { key: 'l4' },
        l5: { key: 'l5' },
        l8: { key: 'l8' },
        l15: { key: 'l15' },
        l16: { key: 'l16' },
        l18: { key: 'l18' },
        l19: { key: 'l19' },
        details: { key: 'list', converter: new (ArrayClassConverterFactory.build(DeclarationDr))(), optional: true, default: () => [] }
    };

    l4: number;
    l5: number;
    l8: number;
    l15: number;
    l16: number;
    l18: number;
    l19: number;
    details: DeclarationDr[];
}
